import { Injectable } from '@angular/core';
import { IStationFilterQuery, SearcherStation, SmartFilterResult } from '@vueling-ng/vy-cdk-searcher';

@Injectable({
  providedIn: 'root'
})
export class FuzzySearchLevenshteinService implements IStationFilterQuery {
  private normalizedText(text: string): string {
    return text
      ?.toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  public queryStations(query: string, list: SearcherStation[]): SmartFilterResult<SearcherStation>[] {
    const filterBy = this.normalizedText(query);
    const stationsFiltered = list.filter(({ name, code, countryName }: SearcherStation) => {
      return [name, code, countryName].some((prop) => this.normalizedText(prop)?.includes(filterBy));
    });
    return stationsFiltered.map((item) => ({ item }));
  }
}
